import PLAYNGOSLOTActions from './PLAYNGOSLOTActions'

export default class PLAYNGOEGAMEActions extends PLAYNGOSLOTActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'PLAYNGO',
      gameType: 'EGAME',
      gameCode: 'PLAYNGO-EGAME-001',
    }

    this.gameName = 'Keno'
  }
}
